'use strict';

var _ = require('lodash');
var MarkerUtil = require('./lib/MarkerUtil');
var LayerStyles = require('./lib/LayerStyles');
var Transform = require('../../Transform');

var MeasurementTransform = Transform.extend({

  collection: 'measurements',

  /**
   * The key on the layer under which the GeoJSON data is stored
   * @type {String}
   */
  geojsonKey: 'data',

  getCollection: function (data) {
    return data.layers;
  },

  /**
   * Default layer styles for different states. Should return an object with
   * three states: active, default, dim
   *
   * @return {Object}
   */
  getLayerStateStyles: function (rlayer) {
    var type = rlayer.type;
    return LayerStyles[type];
  },

  /**
   * Transform a layer type into a type that leaflet understands.
   * Should return one of [circle, marker, polygon, polyline, rectangle].
   *
   * @param  {Object} layer
   * @return {String} type {circle|marker|polygon|polyline|rectangle}
   */
  getLeafletTypeFromLayer: function (rlayer) {
    if (rlayer.type === 'text') {
      return 'marker';
    } else {
      return rlayer.type;
    }
  },

  isLayerClickable: function () {
    return true;
  },

  isLayerEditable: function () {
    return true;
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer
   * from the GeoJSON data and is used to convert a `point` into the appropriate
   * LeafletLayer type.
   */
  // pointToLayerFn: function (rlayer, renderOptions, feature, latlng) {
  //   // NOTE: Style for Marker and Text need to be set here but styles for circle
  //   // can be set using the `style` function
  //   if(OverlayUtil.isOverlay(rlayer.type)) {
  //     return OverlayUtil.getLeafletLayer(rlayer, renderOptions);
  //   } else if (MarkerUtil.isMarker(rlayer.type)) {
  //     var options = MeasurementTransform.getLayerOptions(rlayer);
  //     return MarkerUtil.getLeafletLayer(latlng, options);
  //   } else if (CircleUtil.isCircle(rlayer.type)) {
  //     var radius = feature.properties.radius;
  //     return CircleUtil.getLeafletLayer(latlng, radius);
  //   }
  // },

  /**
   * This is a callback function executed when Leaflet is generating the layer
   * and used to retrieve the LeafletLayer constructor options.
   */
  styleFn: function (rlayer, feature) {
    /* jshint unused:false */
    return MeasurementTransform.getLayerOptions(rlayer);
  }
},

// ## Static Properties

{
  getLayerOptions: function (rlayer) {
    var options;
    var type = rlayer.type;
    var geojson = rlayer.data;
    var defaultStyle, icon;

    if (MarkerUtil.isMarker(rlayer.type)) {
      defaultStyle = LayerStyles[type].default;
      icon = MarkerUtil.getIcon(type, geojson, defaultStyle);
      options = MarkerUtil.getOptions(type, icon, geojson, options);
    } else {
      defaultStyle = LayerStyles[type].default;
      options = _.extend({}, defaultStyle, geojson.properties.style, options || {});
    }

    options.clickable = true;

    return options;
  }
});

module.exports = MeasurementTransform;




// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/measurement/Measurement.js